import type { Genre, MvItem, HeroSlide, TeamMember } from "@/types/mv";

export const genres: Genre[] = [
  { code: "pop", name: "流行", icon: "ri-music-2-line", desc: "旋律抓耳、传唱度高的主流流行音乐，是当下最受欢迎的音乐风格。" },
  { code: "rock", name: "摇滚", icon: "ri-headphone-line", desc: "以电吉他、鼓组为核心，充满力量与情绪张力的现场感音乐。" },
  { code: "hiphop", name: "说唱", icon: "ri-mic-line", desc: "节奏鲜明、歌词犀利的 Hip-Hop 说唱，街头文化与态度表达。" },
  { code: "electronic", name: "电子", icon: "ri-cpu-line", desc: "合成器与电子节拍构建的未来感声场，舞池与氛围感兼备。" },
  { code: "folk", name: "民谣", icon: "ri-music-line", desc: "木吉他与人声为主的叙事民谣，温柔讲述生活与远方。" },
  { code: "jazz", name: "爵士", icon: "ri-album-line", desc: "即兴、摇摆与蓝调交织的经典爵士，适合夜晚静静聆听。" },
  { code: "guofeng", name: "国风", icon: "ri-leaf-line", desc: "融合传统民乐与现代编曲的国风音乐，意境悠远、古韵新声。" },
  { code: "rnb", name: "节奏布鲁斯", icon: "ri-heart-3-line", desc: "丝滑转音与律动节奏结合的 R&B，浪漫又时髦。" },
];

export const mvList: MvItem[] = [
  {
    id: "mv01",
    title: "星河回声",
    artist: "林知夏",
    genreCode: "pop",
    cover: "https://readdy.ai/api/search-image?query=abstract%20cosmic%20music%20video%20still%20with%20drifting%20glowing%20star%20particles%2C%20deep%20dark%20space%20background%2C%20vibrant%20crimson%20and%20neon%20lime%20green%20light%20streaks%2C%20cinematic%20album%20cover%20portrait%20composition%2C%20high%20detail%20artistic%20glossy%20finish&width=600&height=800&seq=mv-cover-01&orientation=portrait",
    duration: "03:52",
    releaseDate: "2026-09-18",
    views: 32800000,
    trending: 98,
    region: "华语",
    era: "2020年代",
    description: "《星河回声》是林知夏全新专辑的同名主打 MV。整支作品以宇宙星辰为意象，讲述在浩瀚人海中寻找共鸣与回响的故事。画面使用大量粒子与光轨特效，配合她标志性的空灵嗓音，营造出辽阔而温暖的听觉空间。",
    tags: ["流行", "空灵", "宇宙意象", "新专辑主打"],
  },
  {
    id: "mv02",
    title: "逆风飞行",
    artist: "陈亦扬",
    genreCode: "rock",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20stormy%20sky%20with%20wind%20and%20lightning%20music%20video%20still%2C%20dark%20moody%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20rock%20album%20cover%20portrait%20composition%2C%20high%20detail%20artistic%20texture&width=600&height=800&seq=mv-cover-02&orientation=portrait",
    duration: "04:18",
    releaseDate: "2026-09-02",
    views: 21500000,
    trending: 95,
    region: "华语",
    era: "2020年代",
    description: "陈亦扬用最直接的摇滚编曲献给每一个不肯停下的人。《逆风飞行》MV 在风暴与坠落之间反复切换，记录主人公在逆境中重新起飞的瞬间，鼓点与吉他像心脏一样轰鸣。",
    tags: ["摇滚", "励志", "现场感", "力量"],
  },
  {
    id: "mv03",
    title: "夜行者",
    artist: "MC阿锐",
    genreCode: "hiphop",
    cover: "https://readdy.ai/api/search-image?query=rainy%20neon%20city%20street%20at%20midnight%20with%20wet%20reflections%20music%20video%20still%2C%20dark%20atmospheric%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20hip%20hop%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-03&orientation=portrait",
    duration: "03:36",
    releaseDate: "2026-08-27",
    views: 28700000,
    trending: 97,
    region: "华语",
    era: "2020年代",
    description: "《夜行者》是 MC阿锐关于深夜与自我对话的作品。MV 取景于雨夜的城市街头，霓虹在积水里被拉长，镜头跟随他穿过街区，把说唱的锋利与孤独城市的温度同时呈现。",
    tags: ["说唱", "街头", "雨夜", "城市"],
  },
  {
    id: "mv04",
    title: "电幻之城",
    artist: "霓虹计划",
    genreCode: "electronic",
    cover: "https://readdy.ai/api/search-image?query=futuristic%20neon%20grid%20cityscape%20with%20holograms%20music%20video%20still%2C%20dark%20cyber%20background%2C%20vibrant%20crimson%20and%20lime%20green%20light%20streaks%2C%20cinematic%20electronic%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-04&orientation=portrait",
    duration: "05:04",
    releaseDate: "2026-09-10",
    views: 19200000,
    trending: 93,
    region: "华语",
    era: "2020年代",
    description: "霓虹计划把合成器的未来感推到极致。《电幻之城》MV 用程序化生成的霓虹网格构建一座虚构都市，节奏层层递进，像在数据洪流中穿行。",
    tags: ["电子", "未来感", "合成器", "视觉系"],
  },
  {
    id: "mv05",
    title: "小镇的黄昏",
    artist: "苏牧",
    genreCode: "folk",
    cover: "https://readdy.ai/api/search-image?query=quiet%20small%20town%20at%20golden%20dusk%20with%20warm%20haze%20music%20video%20still%2C%20soft%20dark%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20folk%20album%20cover%20portrait%20composition%2C%20high%20detail%20nostalgic%20tone&width=600&height=800&seq=mv-cover-05&orientation=portrait",
    duration: "04:02",
    releaseDate: "2026-07-15",
    views: 14300000,
    trending: 88,
    region: "华语",
    era: "2020年代",
    description: "一把木吉他，一条回家的路。《小镇的黄昏》记录苏牧回到长大的小镇所看见的一切，MV 以长镜头呈现黄昏下的街巷，平缓而温暖。",
    tags: ["民谣", "叙事", "怀旧", "温柔"],
  },
  {
    id: "mv06",
    title: "爵士夜巷",
    artist: "江一诺",
    genreCode: "jazz",
    cover: "https://readdy.ai/api/search-image?query=smoky%20jazz%20club%20with%20moody%20amber%20stage%20spotlight%20music%20video%20still%2C%20dark%20velvet%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20jazz%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-06&orientation=portrait",
    duration: "04:47",
    releaseDate: "2026-06-30",
    views: 9800000,
    trending: 84,
    region: "华语",
    era: "2020年代",
    description: "江一诺在深夜的小酒馆里演绎即兴爵士。《爵士夜巷》MV 全程一镜到底，萨克斯与钢琴在暖黄灯光下自由对话，是献给夜晚的浪漫独白。",
    tags: ["爵士", "即兴", "夜晚", "浪漫"],
  },
  {
    id: "mv07",
    title: "墨韵长安",
    artist: "顾清和",
    genreCode: "guofeng",
    cover: "https://readdy.ai/api/search-image?query=ancient%20Chinese%20ink%20painting%20style%20city%20with%20flowing%20brush%20strokes%20music%20video%20still%2C%20dark%20rice%20paper%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20guofeng%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-07&orientation=portrait",
    duration: "04:25",
    releaseDate: "2026-08-08",
    views: 25600000,
    trending: 96,
    region: "华语",
    era: "2020年代",
    description: "顾清和以盛唐长安为背景创作《墨韵长安》。MV 将水墨、古典舞与现代影像结合，一帧帧如水墨长卷徐徐展开，传统与先锋在此相遇。",
    tags: ["国风", "水墨", "古典舞", "意境"],
  },
  {
    id: "mv08",
    title: "心跳频率",
    artist: "苏芮",
    genreCode: "rnb",
    cover: "https://readdy.ai/api/search-image?query=abstract%20glowing%20heartbeat%20waveform%20pulse%20in%20darkness%20music%20video%20still%2C%20deep%20dark%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20rnb%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-08&orientation=portrait",
    duration: "03:28",
    releaseDate: "2026-09-12",
    views: 17400000,
    trending: 92,
    region: "华语",
    era: "2020年代",
    description: "苏芮的全新 R&B 单曲《心跳频率》把恋爱的心动描绘成一条跳动的波形。MV 以抽象视觉呼应歌曲的律动，丝滑转音与画面一同呼吸。",
    tags: ["R&B", "律动", "心动", "丝滑"],
  },
  {
    id: "mv09",
    title: "无限坠落",
    artist: "陈亦扬",
    genreCode: "rock",
    cover: "https://readdy.ai/api/search-image?query=figure%20falling%20through%20abstract%20geometric%20tunnel%20music%20video%20still%2C%20dark%20surreal%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20rock%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-09&orientation=portrait",
    duration: "04:36",
    releaseDate: "2026-05-20",
    views: 12600000,
    trending: 80,
    region: "华语",
    era: "2020年代",
    description: "《无限坠落》展现陈亦扬更实验的一面。MV 用几何隧道与失重画面构建出一场没有终点的下坠，在轰鸣的吉他墙里追问自由的意义。",
    tags: ["摇滚", "实验", "失重", "迷幻"],
  },
  {
    id: "mv10",
    title: "甜味夏天",
    artist: "林知夏",
    genreCode: "pop",
    cover: "https://readdy.ai/api/search-image?query=sunny%20summer%20beach%20with%20bright%20colorful%20sky%20music%20video%20still%2C%20warm%20vivid%20background%2C%20crimson%20and%20lime%20green%20accent%20glow%2C%20cinematic%20pop%20album%20cover%20portrait%20composition%2C%20high%20detail%20playful&width=600&height=800&seq=mv-cover-10&orientation=portrait",
    duration: "03:15",
    releaseDate: "2026-06-11",
    views: 22100000,
    trending: 90,
    region: "华语",
    era: "2020年代",
    description: "一首属于夏天的轻快流行。《甜味夏天》MV 在海边取景，色彩明亮，林知夏骑着单车穿过阳光，把青春的甜全都唱进画面里。",
    tags: ["流行", "夏天", "轻快", "青春"],
  },
  {
    id: "mv11",
    title: "街头诗篇",
    artist: "MC阿锐",
    genreCode: "hiphop",
    cover: "https://readdy.ai/api/search-image?query=graffiti%20covered%20urban%20alley%20at%20night%20music%20video%20still%2C%20dark%20gritty%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20hip%20hop%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-11&orientation=portrait",
    duration: "03:44",
    releaseDate: "2026-04-18",
    views: 13800000,
    trending: 82,
    region: "华语",
    era: "2020年代",
    description: "《街头诗篇》是 MC阿锐写给街头的情书。MV 在涂鸦墙前完成拍摄，押韵与喷漆一同落下，把最真实的生活写进歌词。",
    tags: ["说唱", "街头", "涂鸦", "态度"],
  },
  {
    id: "mv12",
    title: "深海信号",
    artist: "霓虹计划",
    genreCode: "electronic",
    cover: "https://readdy.ai/api/search-image?query=deep%20ocean%20bioluminescent%20abstract%20underwater%20glow%20music%20video%20still%2C%20dark%20deep%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20electronic%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-12&orientation=portrait",
    duration: "04:58",
    releaseDate: "2026-03-22",
    views: 11200000,
    trending: 78,
    region: "华语",
    era: "2020年代",
    description: "《深海信号》把听众带入一片发光的深海。霓虹计划用低频与氛围音效模拟水下声场，画面里的生物荧光随节拍明灭，安静却深邃。",
    tags: ["电子", "氛围", "深海", "沉浸"],
  },
  {
    id: "mv13",
    title: "再见，老屋",
    artist: "苏牧",
    genreCode: "folk",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20wooden%20house%20interior%20with%20warm%20afternoon%20light%20music%20video%20still%2C%20soft%20dark%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20folk%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-13&orientation=portrait",
    duration: "04:12",
    releaseDate: "2026-02-14",
    views: 8900000,
    trending: 74,
    region: "华语",
    era: "2020年代",
    description: "在拆迁来临之前，苏牧回到老屋住了最后一晚。《再见，老屋》MV 用固定机位记录空荡的房间与回忆，唱给每一个离开过家的人。",
    tags: ["民谣", "离别", "回忆", "温暖"],
  },
  {
    id: "mv14",
    title: "月光小径",
    artist: "江一诺",
    genreCode: "jazz",
    cover: "https://readdy.ai/api/search-image?query=moonlit%20garden%20path%20with%20soft%20silver%20glow%20music%20video%20still%2C%20dark%20romantic%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20jazz%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-14&orientation=portrait",
    duration: "04:33",
    releaseDate: "2026-01-09",
    views: 7600000,
    trending: 70,
    region: "华语",
    era: "2020年代",
    description: "《月光小径》是江一诺写给月夜的爵士小品。钢琴像月光一样洒落，MV 在一座夜色花园中完成，安静得能听见每一次呼吸。",
    tags: ["爵士", "月光", "静谧", "钢琴"],
  },
  {
    id: "mv15",
    title: "赤壁东风",
    artist: "顾清和",
    genreCode: "guofeng",
    cover: "https://readdy.ai/api/search-image?query=epic%20ancient%20battlefield%20with%20wind%20and%20flowing%20banners%20music%20video%20still%2C%20dark%20dramatic%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20guofeng%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-15&orientation=portrait",
    duration: "05:12",
    releaseDate: "2025-12-05",
    views: 19800000,
    trending: 86,
    region: "华语",
    era: "2020年代",
    description: "《赤壁东风》取材于三国典故，以磅礴国风乐器铺陈战场的壮阔。MV 以敦煌壁画般的质感还原大风起兮的史诗瞬间。",
    tags: ["国风", "史诗", "战场", "大气"],
  },
  {
    id: "mv16",
    title: "慢半拍",
    artist: "苏芮",
    genreCode: "rnb",
    cover: "https://readdy.ai/api/search-image?query=slow%20motion%20abstract%20silk%20fabric%20flowing%20in%20darkness%20music%20video%20still%2C%20dark%20elegant%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20rnb%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-16&orientation=portrait",
    duration: "03:21",
    releaseDate: "2025-11-20",
    views: 10400000,
    trending: 76,
    region: "华语",
    era: "2020年代",
    description: "《慢半拍》唱的是那种暧昧又克制的心动。MV 用丝绸与慢镜头表达情绪的延展，苏芮的气声让整首歌像一次轻轻的叹息。",
    tags: ["R&B", "暧昧", "慢镜头", "气声"],
  },
  {
    id: "mv17",
    title: "追光者",
    artist: "林知夏",
    genreCode: "pop",
    cover: "https://readdy.ai/api/search-image?query=silhouette%20chasing%20a%20beam%20of%20light%20in%20dense%20fog%20music%20video%20still%2C%20dark%20moody%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20pop%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-17&orientation=portrait",
    duration: "03:58",
    releaseDate: "2025-10-10",
    views: 26900000,
    trending: 89,
    region: "华语",
    era: "2020年代",
    description: "《追光者》献给所有在黑暗里still向前的人。MV 以浓雾中的光束隐喻希望，林知夏的歌声一路陪伴，直到光落在她身上。",
    tags: ["流行", "希望", "光影", "陪伴"],
  },
  {
    id: "mv18",
    title: "摇滚青年",
    artist: "陈亦扬",
    genreCode: "rock",
    cover: "https://readdy.ai/api/search-image?query=young%20rock%20band%20performing%20on%20stage%20with%20amplifiers%20music%20video%20still%2C%20dark%20concert%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20rock%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-18&orientation=portrait",
    duration: "04:20",
    releaseDate: "2025-08-15",
    views: 14700000,
    trending: 79,
    region: "华语",
    era: "2020年代",
    description: "《摇滚青年》是一首关于热爱的进行曲。MV 记录乐队在排练室里从争执到合奏的全过程，最后一切都在舞台上爆发。",
    tags: ["摇滚", "青春", "乐队", "现场"],
  },
  {
    id: "mv19",
    title: "午夜霓虹",
    artist: "霓虹计划",
    genreCode: "electronic",
    cover: "https://readdy.ai/api/search-image?query=neon%20signs%20reflecting%20on%20wet%20asphalt%20at%20night%20music%20video%20still%2C%20dark%20urban%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20electronic%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-19&orientation=portrait",
    duration: "05:22",
    releaseDate: "2025-06-06",
    views: 9100000,
    trending: 72,
    region: "华语",
    era: "2020年代",
    description: "《午夜霓虹》是霓虹计划最受欢迎的现场曲目之一。MV 完整收录了音乐节当晚的画面，上万人的灯光与雨夜交融成一片霓虹海。",
    tags: ["电子", "现场", "音乐节", "夜"],
  },
  {
    id: "mv20",
    title: "山那边",
    artist: "苏牧",
    genreCode: "folk",
    cover: "https://readdy.ai/api/search-image?query=misty%20mountain%20landscape%20at%20dawn%20music%20video%20still%2C%20soft%20dark%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20folk%20album%20cover%20portrait%20composition%2C%20high%20detail%20serene&width=600&height=800&seq=mv-cover-20&orientation=portrait",
    duration: "04:41",
    releaseDate: "2025-03-30",
    views: 6800000,
    trending: 66,
    region: "华语",
    era: "2020年代",
    description: "《山那边》是一段关于远行的民谣。MV 跟随苏牧徒步穿过清晨的山雾，歌声与脚步一起，翻过一座又一座山。",
    tags: ["民谣", "远行", "山野", "治愈"],
  },
  {
    id: "mv21",
    title: "Neon Rain",
    artist: "Aria West",
    genreCode: "pop",
    cover: "https://readdy.ai/api/search-image?query=rainy%20neon%20urban%20night%20with%20colorful%20reflections%20music%20video%20still%2C%20dark%20cinematic%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20pop%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-21&orientation=portrait",
    duration: "03:47",
    releaseDate: "2026-09-05",
    views: 41200000,
    trending: 99,
    region: "欧美",
    era: "2020年代",
    description: "全球热单《Neon Rain》官方 MV。Aria West 在霓虹雨中起舞，把失恋拍成一场绚烂的告别。视觉与旋律同样抓耳，上线即登顶多国榜单。",
    tags: ["欧美", "热单", "流行", "霓虹"],
  },
  {
    id: "mv22",
    title: "Midnight Drive",
    artist: "The Static Ones",
    genreCode: "rock",
    cover: "https://readdy.ai/api/search-image?query=car%20driving%20on%20an%20empty%20highway%20at%20night%20with%20headlights%20music%20video%20still%2C%20dark%20moody%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20rock%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-22&orientation=portrait",
    duration: "04:55",
    releaseDate: "2026-07-28",
    views: 18600000,
    trending: 87,
    region: "欧美",
    era: "2020年代",
    description: "英伦摇滚新锐 The Static Ones 的《Midnight Drive》。MV 记录一场没有目的地的午夜公路旅行，车灯划开夜色，吉他一路轰鸣。",
    tags: ["欧美", "摇滚", "公路", "公路旅行"],
  },
  {
    id: "mv23",
    title: "Tokyo Lights",
    artist: "Yuki",
    genreCode: "pop",
    cover: "https://readdy.ai/api/search-image?query=dense%20night%20city%20skyline%20with%20warm%20lantern%20glow%20music%20video%20still%2C%20dark%20urban%20background%2C%20vibrant%20crimson%20and%20lime%20green%20glow%2C%20cinematic%20pop%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-23&orientation=portrait",
    duration: "03:33",
    releaseDate: "2026-08-19",
    views: 23300000,
    trending: 94,
    region: "日韩",
    era: "2020年代",
    description: "Yuki 的《Tokyo Lights》捕捉都市夜晚的光与孤独。MV 走遍东京的街角与天台，把拥挤城市里的心事唱得温柔又清亮。",
    tags: ["日韩", "流行", "都市", "夜景"],
  },
  {
    id: "mv24",
    title: "千禧之夏",
    artist: "银河少年",
    genreCode: "rock",
    cover: "https://readdy.ai/api/search-image?query=retro%202000s%20summer%20vibe%20with%20vintage%20film%20grain%20music%20video%20still%2C%20warm%20dark%20background%2C%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20rock%20album%20cover%20portrait%20composition%2C%20high%20detail%20nostalgic&width=600&height=800&seq=mv-cover-24&orientation=portrait",
    duration: "04:08",
    releaseDate: "2003-07-12",
    views: 15600000,
    trending: 68,
    region: "华语",
    era: "2000年代",
    description: "华语摇滚经典《千禧之夏》高清修复版 MV。银河少年用失真吉他和直白的歌词，记录了一代人关于千禧年夏天的集体记忆。",
    tags: ["经典", "摇滚", "千禧", "回忆"],
  },
  {
    id: "mv25",
    title: "昨日重现",
    artist: "王韵",
    genreCode: "pop",
    cover: "https://readdy.ai/api/search-image?query=vintage%20warm%20nostalgic%20film%20grain%20memory%20scene%20music%20video%20still%2C%20soft%20dark%20background%2C%20warm%20crimson%20and%20lime%20accent%20glow%2C%20cinematic%20pop%20album%20cover%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=mv-cover-25&orientation=portrait",
    duration: "03:40",
    releaseDate: "2014-05-09",
    views: 20400000,
    trending: 71,
    region: "华语",
    era: "2010年代",
    description: "《昨日重现》是王韵最具代表性的情歌之一。MV 用胶片质感重温旧时光，把一段没能说出口的告白留在泛黄的画面里。",
    tags: ["经典", "情歌", "怀旧", "温暖"],
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: "hero01",
    mvId: "mv21",
    image: "https://readdy.ai/api/search-image?query=cinematic%20rainy%20neon%20city%20music%20video%20hero%20still%2C%20dramatic%20dark%20atmospheric%20background%20with%20strong%20contrast%2C%20vibrant%20crimson%20and%20lime%20green%20light%20streaks%2C%20wide%20film%20poster%20composition%2C%20high%20detail%20artistic&width=1600&height=900&seq=mv-hero-01&orientation=landscape",
    tagline: "全球热单官方 MV · 上线即登顶",
  },
  {
    id: "hero02",
    mvId: "mv01",
    image: "https://readdy.ai/api/search-image?query=epic%20cosmic%20space%20music%20video%20hero%20still%2C%20dramatic%20dark%20atmospheric%20background%20with%20strong%20contrast%2C%20vibrant%20crimson%20and%20lime%20green%20light%20streaks%2C%20wide%20film%20poster%20composition%2C%20high%20detail%20artistic&width=1600&height=900&seq=mv-hero-02&orientation=landscape",
    tagline: "林知夏全新主打 · 星河回声",
  },
  {
    id: "hero03",
    mvId: "mv07",
    image: "https://readdy.ai/api/search-image?query=epic%20ancient%20Chinese%20ink%20city%20music%20video%20hero%20still%2C%20dramatic%20dark%20atmospheric%20background%20with%20strong%20contrast%2C%20vibrant%20crimson%20and%20lime%20green%20light%20streaks%2C%20wide%20film%20poster%20composition%2C%20high%20detail%20artistic&width=1600&height=900&seq=mv-hero-03&orientation=landscape",
    tagline: "国风巨制 · 墨韵长安",
  },
  {
    id: "hero04",
    mvId: "mv03",
    image: "https://readdy.ai/api/search-image?query=rainy%20neon%20hip%20hop%20street%20music%20video%20hero%20still%2C%20dramatic%20dark%20atmospheric%20background%20with%20strong%20contrast%2C%20vibrant%20crimson%20and%20lime%20green%20light%20streaks%2C%20wide%20film%20poster%20composition%2C%20high%20detail%20artistic&width=1600&height=900&seq=mv-hero-04&orientation=landscape",
    tagline: "MC阿锐 · 夜行者官方 MV",
  },
  {
    id: "hero05",
    mvId: "mv04",
    image: "https://readdy.ai/api/search-image?query=futuristic%20neon%20electronic%20city%20music%20video%20hero%20still%2C%20dramatic%20dark%20atmospheric%20background%20with%20strong%20contrast%2C%20vibrant%20crimson%20and%20lime%20green%20light%20streaks%2C%20wide%20film%20poster%20composition%2C%20high%20detail%20artistic&width=1600&height=900&seq=mv-hero-05&orientation=landscape",
    tagline: "霓虹计划 · 电幻之城",
  },
];

export const teamMembers: TeamMember[] = [
  {
    name: "周望舒",
    role: "创始人 / 内容总监",
    avatar: "https://readdy.ai/api/search-image?query=professional%20friendly%20portrait%20of%20a%20young%20creative%20director%2C%20dark%20studio%20background%2C%20warm%20crimson%20rim%20light%2C%20clean%20modern%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=mv-team-01&orientation=squarish",
  },
  {
    name: "陆时安",
    role: "主编 / 乐评人",
    avatar: "https://readdy.ai/api/search-image?query=professional%20friendly%20portrait%20of%20a%20thoughtful%20music%20editor%2C%20dark%20studio%20background%2C%20warm%20crimson%20rim%20light%2C%20clean%20modern%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=mv-team-02&orientation=squarish",
  },
  {
    name: "苏叶",
    role: "视觉设计负责人",
    avatar: "https://readdy.ai/api/search-image?query=professional%20friendly%20portrait%20of%20a%20young%20female%20visual%20designer%2C%20dark%20studio%20background%2C%20warm%20crimson%20rim%20light%2C%20clean%20modern%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=mv-team-03&orientation=squarish",
  },
  {
    name: "何一鸣",
    role: "技术负责人",
    avatar: "https://readdy.ai/api/search-image?query=professional%20friendly%20portrait%20of%20a%20calm%20tech%20lead%2C%20dark%20studio%20background%2C%20warm%20crimson%20rim%20light%2C%20clean%20modern%20editorial%20photography%2C%20high%20detail&width=400&height=400&seq=mv-team-04&orientation=squarish",
  },
];

export const siteStats = [
  { label: "收录 MV", value: "12,000+" },
  { label: "合作歌手", value: "3,600+" },
  { label: "音乐风格", value: "8 大类" },
  { label: "月活跃乐迷", value: "860 万" },
];

export const aboutInfo = {
  mission: "红桃MV视频致力于成为音乐爱好者最信赖的 MV 聚合与观看平台，让每一支好作品都被更多认真听歌的人看见。",
  intro:
    "我们相信音乐视频不只是歌曲的附属品，而是一种独立的艺术表达。红桃MV视频持续收录全球最新、最热门的 MV 作品，覆盖流行、摇滚、说唱、电子、国风等多元风格，并通过清晰的分类、权威的榜单与智能推荐，帮助乐迷高效发现真正喜欢的内容。",
  email: "hello@hongtaomv.com",
  phone: "400-820-2026",
  address: "上海市徐汇区音乐产业园区 A 座 12 层",
};